






























































































import { defineComponent, ref } from '@vue/composition-api'
import { IOrderData, IAvmDataSubmit } from '@/api/types'
import { avmSubmitReport } from '@/api/orders'
import { notifyError, notifyMessage } from '@/utils/error-display'

const defaultAvmDataSubmit: IAvmDataSubmit = {
  orderId: 0,
  avmReportFile: null,
  product: '',
  confidence: 0,
  fSD: 0,
  value: 0,
  highValue: 0,
  lowValue: 0
}

export default defineComponent({
  name: 'AvmUpload',
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { attrs }) {
    const modelValue = ref<IOrderData>((attrs['v-model'] as IOrderData))
    const hasChanges = ref(false)
    const submitting = ref(false)
    const avmDataSubmit = ref<IAvmDataSubmit>(defaultAvmDataSubmit)
    const disableSubmit = ref(true)

    const handleChange = () => {
      hasChanges.value = true
      disableSubmit.value = !isValid()
    }

    const isValid = (): boolean => {
      if (submitting.value) return false
      if (!hasChanges.value) return false
      if (avmDataSubmit.value.value === 0) return false
      if (avmDataSubmit.value.fSD === 0) return false
      if (avmDataSubmit.value.confidence === 0) return false
      if (avmDataSubmit.value.product === '') return false
      if (avmDataSubmit.value.avmReportFile === null) return false
      return true
    }
    const saveChanges = async() => {
      if (hasChanges.value) {
        submitting.value = true
        await submitAvmUpload()
        submitting.value = false
      }
      hasChanges.value = false
    }

    const submitAvmUpload = async() => {
      avmDataSubmit.value.orderId = modelValue.value.orderId
      const result = await avmSubmitReport(
        modelValue.value.orderId,
        avmDataSubmit.value
      )
      if (result.startsWith('Error')) {
        notifyError(result)
      } else {
        notifyMessage({
          title: 'Success',
          message: `AVM Report uploaded for ${modelValue.value.orderId} successfully.`,
          type: 'success',
          duration: 6000
        })
        setTimeout(() => {
          // eslint-disable-next-line no-self-assign
          window.location.href = window.location.href
        }, 3000)
      }
      return true
    }

    const handleBeforeUpload = async(file: File) => {
      avmDataSubmit.value.avmReportFile = file
      handleChange()
    }

    return {
      modelValue,
      avmDataSubmit,
      hasChanges,
      submitting,

      disableSubmit,
      saveChanges,
      handleBeforeUpload,
      handleChange
    }
  }
})
